import axiosInstance from "@/apis/axios-instance";
import { XBRLTreeViewResponse } from "@/apis/xbrl-view/types";
import {
  AddStructuralTagRequest,
  BatchUpdateCellValuesRequest,
  EditableTablePreviewResponseV2,
  ReorderTagRequest,
} from "./types";

export const getEditablePreview = async (
  workbookId: string,
  tableId: string,
  notIsSumMemberTags: string[],
): Promise<EditableTablePreviewResponseV2> => {
  const response = await axiosInstance.get(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview`,
    {
      params: {
        notSumFields: notIsSumMemberTags.length > 0 ? notIsSumMemberTags : "",
      },
      paramsSerializer: {
        indexes: null,
      },
    },
  );
  return response.data;
};

export const updateEditablePreviewCells = async (
  workbookId: string,
  tableId: string,
  request: BatchUpdateCellValuesRequest,
): Promise<void> => {
  await axiosInstance.patch(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview/cells`,
    request,
  );
};

export const addEditablePreviewTag = async (
  workbookId: string,
  tableId: string,
  request: AddStructuralTagRequest,
): Promise<void> => {
  await axiosInstance.post(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview/tags`,
    request,
  );
};

export const removeEditablePreviewTag = async (
  workbookId: string,
  tableId: string,
  tagKey: string,
  roleKey: string,
): Promise<void> => {
  await axiosInstance.delete(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview/tags/${tagKey}`,
    {
      params: { roleKey },
    },
  );
};

export const reorderTag = async (
  workbookId: string,
  tableId: string,
  request: ReorderTagRequest,
): Promise<void> => {
  await axiosInstance.patch(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview/tags/reorder`,
    request,
  );
};

export const getEditableTreeView = async (
  workbookId: string,
  tableId: string,
): Promise<XBRLTreeViewResponse> => {
  const response = await axiosInstance.get(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-tree-view`,
  );
  return response.data;
};

export const resetEditablePreviewOverrides = async (
  workbookId: string,
  tableId: string,
  roleKey?: string,
): Promise<void> => {
  await axiosInstance.delete(
    `/v2/xbrl-view/workbooks/${workbookId}/tables/${tableId}/editable-preview/overrides`,
    {
      params: roleKey ? { roleKey } : undefined,
    },
  );
};
